// The only way the browser reaches Finnhub.
//
// There is no API key in this file and none anywhere else on the client. The
// key used to be `REACT_APP_FINNHUB_KEY`, which webpack inlines into the bundle
// at build time — it shipped in main.js and rode in the query string of every
// request. It now lives only in the Netlify function's environment.
//
// Every call carries the user's own Supabase access token, because the proxy
// requires one. The app only renders with a session (guests get an anonymous
// one), so there is no state in which a legitimate call cannot produce a token.

import { supabase } from "../lib/supabase";

const ENDPOINT = "/.netlify/functions/finnhub";

async function token() {
  if (!supabase) return null;
  try {
    const { data } = await supabase.auth.getSession();
    return data?.session?.access_token || null;
  } catch { return null; }
}

/**
 * One call to the proxy. Resolves to the payload, or null.
 *
 * Never throws: every call site in this app already treated a failed fetch as
 * "no data" and rendered an empty state, and changing that contract here would
 * turn a quiet gap into a crash.
 */
export async function callFinnhub(op, params = {}) {
  const t = await token();
  if (!t) return null;
  try {
    const res = await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${t}` },
      body: JSON.stringify({ op, ...params }),
    });
    if (!res.ok) {
      if (res.status !== 429) console.warn(`[finnhub] ${op}: HTTP ${res.status}`);
      return null;
    }
    const data = await res.json();
    return data?.error ? null : data;
  } catch (e) {
    console.warn(`[finnhub] ${op}:`, e.message);
    return null;
  }
}
